<button type="button" class="btn px-2 shadow-sm" [ngClass]="[outline ? styles[type]?.classOutline : styles[type]?.class , btnBlock ? 'btn-block' : '']" (click)="click()" [disabled]="disabled" [hidden]="hidden">
  <i *ngIf="type != s1ButtonType.Next && !onlyText"
    class="{{ icon ? icon : styles[type]?.icon }}"></i>
  <span *ngIf="!onlyIcon"> {{ (label ? label : styles[type]?.label) | translate }} </span>
  <i *ngIf="type == s1ButtonType.Next && !onlyText"
    class="{{ icon ? icon : styles[type]?.icon }}"></i> 
</button>